import React from 'react';
import { RouteObject, Navigate } from 'react-router';

import { Auth0Guard } from '@anyx/common-auth';
import { Auth0Permissions, Restricted } from '@anyx/common-permission';
import { ReportAdvertisingRoutePath } from '@anyx/common-routing';
import { UnauthorizedMessage } from '@anyx/shared-ui';

const AdvertisingListPage = React.lazy(() =>
  import('./pages/list').then((module) => ({ default: module.AdvertisingListPage }))
);

const AdvertisingTemplate = React.lazy(() =>
  import('./templates').then((module) => ({ default: module.AdvertisingTemplate }))
);

export const routes: RouteObject[] = [
  {
    path: 'advertising',
    element: (
      <Auth0Guard>
        <Restricted
          permissions={[[Auth0Permissions.CAN_USE_ANALYTICS]]}
          fallback={<UnauthorizedMessage />}
        >
          <AdvertisingTemplate />
        </Restricted>
      </Auth0Guard>
    ),
    children: [
      {
        path: 'list',
        element: <AdvertisingListPage />,
      },
      {
        index: true,
        element: (
          <Navigate
            to={ReportAdvertisingRoutePath({ workspaceStoreId: null }).list().path}
            replace={true}
          />
        ),
      },
    ],
  },
];
